
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { LoaderIcon } from "lucide-react";

const DemographicLoadingState = () => {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Demographic Analysis</CardTitle>
      </CardHeader>
      <CardContent className="flex items-center justify-center py-8">
        <LoaderIcon className="h-8 w-8 text-nation-blue animate-spin" />
        <p className="ml-2">Loading demographic data...</p>
      </CardContent>
    </Card>
  );
};

export default DemographicLoadingState;
